import API from './API.ts'

export default {
  //
  // GET
  //
  getBookingGroup ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/show', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getBookingGroupsIndex ({ requestId, offset, visibleBookingGroups, sortedColumn, sortedDesc, filterCustom, checkinDateFilterDate, checkinDateFilterRange, checkoutDateFilterDate, checkoutDateFilterRange, bookingDateFilterDate, bookingDateFilterRange, searchString }) {
    return API.httpClient.get('booking-groups', {
      params: {
        request_id: requestId,
        offset,
        visible_booking_groups: visibleBookingGroups,
        sorted_column: sortedColumn,
        sorted_desc: sortedDesc,
        filter_custom: filterCustom ?? [],
        checkin_date_filter_date: checkinDateFilterDate?.format('YYYY-MM-DD') ?? null,
        checkin_date_filter_range: (checkinDateFilterRange[0] && checkinDateFilterRange[1])
          ? [
              checkinDateFilterRange[0]?.format('YYYY-MM-DD') ?? null,
              checkinDateFilterRange[1]?.format('YYYY-MM-DD') ?? null
            ]
          : [],
        checkout_date_filter_date: checkoutDateFilterDate?.format('YYYY-MM-DD') ?? null,
        checkout_date_filter_range: (checkoutDateFilterRange[0] && checkoutDateFilterRange[1])
          ? [
              checkoutDateFilterRange[0]?.format('YYYY-MM-DD') ?? null,
              checkoutDateFilterRange[1]?.format('YYYY-MM-DD') ?? null
            ]
          : [],
        booking_date_filter_date: bookingDateFilterDate?.format('YYYY-MM-DD') ?? null,
        booking_date_filter_range: (bookingDateFilterRange[0] && bookingDateFilterRange[1])
          ? [
              bookingDateFilterRange[0]?.format('YYYY-MM-DD') ?? null,
              bookingDateFilterRange[1]?.format('YYYY-MM-DD') ?? null
            ]
          : [],
        search_string: searchString
      }
    })
  },
  getCharges ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/charges', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getAccommodationSums ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/accommodation-sums', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getCart ({ bookingGroupId, readConsumption = false }) {
    return API.httpClient.get(readConsumption ? 'booking-groups/consumption' : 'booking-groups/cart', {
      params: {
        booking_group_id: bookingGroupId,
        defer_consumption: true
      }
    })
  },
  getInvoices ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/invoices', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getReceipts ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/receipts', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getPayments ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/payments', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getEmails ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/emails', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },
  getEditingRecords ({ bookingGroupId }) {
    return API.httpClient.get('booking-groups/editing-records', {
      params: {
        booking_group_id: bookingGroupId
      }
    })
  },

  //
  // POST
  //
  saveBookingGroup ({ bookingGroup, displayedTotal }) {
    const customer = Object.assign({}, bookingGroup.customer)
    customer.bookings = null
    const bookings = bookingGroup.bookings.map((booking) => {
      const customer = booking.customer ? Object.assign({}, booking.customer) : null
      return {
        booking_id: booking.id || null,
        position_id: booking.position?.id,
        category_id: booking.category.id,
        check_in: booking.checkIn.format('YYYY-MM-DD'),
        check_out: booking.checkOut.format('YYYY-MM-DD'),
        customer,
        adults: booking.adults,
        children: booking.children,
        dogs: booking.dogs,
        booking_field_changes: booking.booking_field_changes || [],
        lodging_type_id: booking.lodgingType?.id,
        cancellation_policy_id: booking.cancellationPolicy?.id,
        applied_fees: booking.appliedFees
      }
    })

    return API.httpClient.post('booking-groups/store', {
      customer_id: customer.id,
      customer,
      name: bookingGroup.name,
      check_in: bookingGroup.checkIn.format('YYYY-MM-DD'),
      check_out: bookingGroup.checkOut.format('YYYY-MM-DD'),
      bookings,
      same_cancellation_policy_for_all_bookings: bookingGroup.sameCancellationPolicyForAllBookings,
      cancellation_policy_id: bookingGroup.cancellationPolicy?.id,
      applied_fees: bookingGroup.appliedFees,
      total: displayedTotal
    })
  },
  addBooking ({ bookingGroupId, bookingId }) {
    return API.httpClient.post('booking-groups/add-booking', {
      booking_group_id: bookingGroupId,
      booking_id: bookingId
    })
  },
  updateRemarks ({ bookingGroupId, remarks }) {
    return API.httpClient.post('booking-groups/update-remarks', {
      booking_group_id: bookingGroupId,
      remarks,
      timestamp: Date.now()
    })
  },
  sendBookingConfirmation ({ bookingGroupId }) {
    return API.httpClient.post('booking-groups/send-confirmation', {
      booking_group_id: bookingGroupId
    })
  },
  parkCart ({ bookingGroupId, charges }) {
    const items = charges.map((charge) => {
      const item = Object.assign({}, charge)
      item.delivery_date = charge.delivery_date ? charge.delivery_date.format('YYYY-MM-DD') : null
      item.position_id = charge.position ? charge.position.id : null
      item.product_id = charge.product.id
      item.position = null
      item.product = null
      item.booking = null
      return item
    })
    return API.httpClient.post('booking-groups/park', {
      booking_group_id: bookingGroupId,
      items
    })
  }
}
